<script setup>
import Layout from '../Layouts/App'
import { Head } from '@inertiajs/vue3'
import {throttle} from "lodash";
import {onMounted, ref} from "vue";
import PromoScreen from "../Components/Promo/Screens/PromoScreen.vue";
import MainScreen from "../Components/Promo/Screens/MainScreen.vue";
import PlayerScreen from "../Components/Promo/Screens/PlayerScreen.vue";
import MasterScreen from "../Components/Promo/Screens/MasterScreen.vue";
import SubscribeScreen from "../Components/Promo/Screens/SubscribeScreen.vue";
import FeaturesScreen from "../Components/Promo/Screens/FeaturesScreen.vue";


const deg = ref(0);
const renderer = ref(null);
const camera = ref(null);
const diceWrappers = [];

const props = defineProps({
    title: String,
    theme: String
})

window.addEventListener('scroll', throttle(() => {
    calcScreensActivity();
    calcDicesPosition();
}, 60), false);

onMounted(() => {
    document.querySelectorAll('.dice-wrapper').forEach(diceWrapper => {
        diceWrappers.push(diceWrapper);
    });

    calcScreensActivity();
    calcDicesPosition(true);
});

const calcScreensActivity = () => {
    const visibleOffset = window.innerHeight/3;
    document.querySelectorAll('.section-screen').forEach(screen => {
        if (
            (
                //верх экрана на уровне или выше начала блока
                (window.scrollY <= screen.offsetTop)
                //низ экрана на уровне или ниже конца блока
                && (window.scrollY+window.innerHeight >= screen.offsetTop + screen.clientHeight)
            ) || (
                //центр экрана ниже начала блока
                (window.scrollY+window.innerHeight/2 > screen.offsetTop)
                //центр экрана выше конца блока
                && (window.scrollY+window.innerHeight/2 < screen.offsetTop + screen.clientHeight)
            ) || (
                //доскроллили 1/4 блока сверху
                (window.scrollY + window.innerHeight >= screen.offsetTop + visibleOffset)
                //доскроллили 1/4 блока снизу
                && (window.scrollY <= screen.offsetTop - visibleOffset)
            )
        ) {
            if (!screen.classList.contains('active')) {
                screen.classList.add('active');
                screen.classList.add('visited');
            }
        } else {
            screen.classList.remove('active');
        }
    });
}

const calcDicesPosition = (force) => {
    const scrollPosition = window.innerHeight/2;

    diceWrappers.forEach(diceWrapper => {
        const screenDices = document.querySelectorAll(`.screen-dice.${diceWrapper.dataset.dice}`);
        const curScreenDice = Array.from(screenDices).find(screenDice => screenDice.querySelector('.dice-wrapper'));
        let nextScreenDice = curScreenDice;

        screenDices.forEach(screenDice => {
            const screenDicePosition = screenDice.getBoundingClientRect().top;
            const nextScreenDicePosition =  nextScreenDice.getBoundingClientRect().top;

            if (Math.abs(scrollPosition - screenDicePosition) < Math.abs(scrollPosition - nextScreenDicePosition)) {
                nextScreenDice = screenDice;
            }
        });

        if (nextScreenDice) {
            if ((nextScreenDice !== curScreenDice) || force) {
                if (curScreenDice.classList.contains('active')) {
                    curScreenDice.classList.remove('active');
                }

                setTimeout(() => {
                    if (!nextScreenDice.contains(diceWrapper)) {
                        nextScreenDice.appendChild(diceWrapper);
                    }

                    setTimeout(() => {
                        if (!nextScreenDice.classList.contains('active')) {
                            nextScreenDice.classList.add('active');
                        }
                    }, 10);
                }, 300);
            }
        }
    })
}
</script>

<template>
    <Layout :theme="theme">
        <Head>
            <title>{{ title }}</title>
        </Head>
        <div class="overflow-hidden">
            <PromoScreen/>
            <MainScreen/>
            <PlayerScreen/>
            <MasterScreen/>
            <FeaturesScreen/>
            <SubscribeScreen/>
        </div>
    </Layout>
</template>

<style lang="scss">
    //swiper autoplay
    .autoplay-progress {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 10;
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: rgb(249 115 22);


        svg {
            --progress: 0;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;
            width: 100%;
            height: 100%;
            stroke-width: 4px;
            stroke: rgb(249 115 22);
            fill: none;
            stroke-dashoffset: calc(125.6 * (1 - var(--progress)));
            stroke-dasharray: 125.6;
            transform: rotate(-90deg);
        }
    }

    //swiper nav
    .swiper-button-prev, .swiper-button-next {
        color: rgb(249 115 22);
    }

    .swiper-pagination-bullet {
        @apply relative w-[24px] h-[8px] rounded-[4px] bg-transparent transition-colors duration-300;
        margin: 0 -1px!important;

        &:before {
            content: '';
            @apply absolute block w-[8px] h-[8px] rounded-[4px] left-[8px] top-0 bg-gray-500 -z-10;
        }
    }
    .swiper-pagination-bullet-active {
        &:before {
            @apply bg-current;
        }
    }

    .screen-dice {
        @apply absolute duration-300 transition-opacity;

        &.d4 {
            @apply w-[140px] h-[140px];
        }

        &.d6 {
            @apply w-[100px] h-[100px];
        }

        &.d8 {
            @apply w-[150px] h-[150px];
        }

        &.d10 {
            @apply w-[150px] h-[150px] md:w-[150px] md:h-[150px] ;
        }

        &.d20 {
            @apply w-[150px] h-[150px] md:w-[180px] md:h-[180px];
        }

        canvas {
            width: 100% !important;
            height: 100% !important;
        }
    }
</style>
